<template>
  <div class="login-layout">
    <div class="login-layout__cover">
      <login-slider></login-slider>
    </div>

    <div class="login-layout__auth">
      <div class="login-layout__auth-content">
        <svg class="login-logo" width="356" height="141" viewBox="0 0 356 141" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M183.651 89.229C183.666 91.5445 183.203 93.8396 182.298 95.9664C181.428 98.0269 180.191 99.9089 178.653 101.515C175.455 104.836 171.056 106.692 166.481 106.646C164.198 106.662 161.936 106.192 159.84 105.274C155.722 103.479 152.439 100.144 150.669 95.9664C149.764 93.8396 149.312 91.5445 149.332 89.229V65.7219C149.332 64.3703 149.995 63.6818 151.343 63.6818C151.866 63.6716 152.368 63.8654 152.751 64.2224C153.153 64.6049 153.369 65.1507 153.339 65.7117V89.229C153.329 91.0141 153.691 92.7839 154.4 94.4159C155.742 97.6087 158.246 100.154 161.393 101.515C163.007 102.23 164.747 102.597 166.506 102.587C168.246 102.602 169.97 102.235 171.564 101.515C174.681 100.128 177.16 97.5883 178.502 94.4159C179.206 92.7788 179.568 91.0141 179.558 89.229V65.7219C179.528 65.1507 179.769 64.5947 180.207 64.2326C180.614 63.8807 181.137 63.6869 181.675 63.692C183.017 63.692 183.686 64.3703 183.686 65.7321L183.651 89.229Z" fill="#000100"/>
          <path d="M233.635 105.086C233.625 105.591 233.439 106.075 233.107 106.458C232.745 106.896 232.202 107.136 231.639 107.111C231.096 107.111 230.578 106.876 230.226 106.458C229.864 106.091 229.658 105.601 229.638 105.086V81.3492C229.653 79.355 229.251 77.3863 228.462 75.5604C227.697 73.8059 226.622 72.2095 225.289 70.8529C223.937 69.486 222.338 68.3945 220.583 67.6295C218.804 66.8389 216.883 66.436 214.942 66.436C212.961 66.4258 211.001 66.8338 209.181 67.6295C207.426 68.3945 205.827 69.486 204.475 70.8529C201.73 73.6325 200.201 77.4169 200.241 81.3492V105.086C200.221 105.601 200.015 106.091 199.653 106.458C199.266 106.886 198.718 107.126 198.145 107.111C197.049 107.111 196.38 106.432 196.134 105.07V65.008C196.134 63.6462 196.802 62.9679 198.145 62.9679C198.678 62.9577 199.201 63.1362 199.618 63.4779C200.05 63.8451 200.287 64.401 200.262 64.9723V69.6237C201.911 67.3337 204.083 65.4874 206.591 64.2378C211.493 61.7897 217.195 61.6163 222.232 63.7584C226.732 65.6761 230.302 69.3228 232.167 73.8977C233.147 76.2591 233.65 78.794 233.635 81.3543V105.086Z" fill="#000100"/>
          <path d="M249.04 56.0772C248.427 56.0721 247.839 56.3067 247.391 56.7301C246.919 57.1738 246.662 57.8062 246.687 58.4591C246.712 59.7647 247.753 60.8205 249.04 60.846C249.699 60.8613 250.337 60.6063 250.8 60.1319C251.257 59.7035 251.519 59.1068 251.524 58.4744C251.549 57.8215 251.288 57.1891 250.815 56.7454C250.332 56.3067 249.704 56.0721 249.055 56.0925" fill="#000100"/>
          <path d="M251.152 105.55C251.137 106.065 250.926 106.555 250.569 106.922C250.182 107.35 249.634 107.59 249.06 107.58C248 107.468 247.16 106.616 247.049 105.54V65.8393C247.049 65.2885 247.286 64.7682 247.698 64.4112C248.06 64.044 248.543 63.8349 249.05 63.8145C249.613 63.7992 250.156 64.0134 250.559 64.4112C250.936 64.7835 251.147 65.3038 251.142 65.8393L251.152 105.55Z" fill="#000100"/>
          <path d="M283.841 107.467C280.87 107.483 277.929 106.876 275.199 105.682C269.88 103.382 265.646 99.0877 263.379 93.6916C262.202 90.9222 261.604 87.9386 261.619 84.9243C261.599 81.9305 262.197 78.9621 263.379 76.2182C264.515 73.5711 266.134 71.1638 268.145 69.1237C270.161 67.0785 272.554 65.4566 275.184 64.3499C277.919 63.1921 280.86 62.6005 283.826 62.6209C286.773 62.6005 289.694 63.187 292.409 64.3499C295.023 65.4668 297.396 67.0887 299.402 69.1237C301.413 71.1638 303.032 73.5711 304.168 76.2182C305.35 78.9621 305.948 81.9305 305.928 84.9243C305.943 87.9386 305.345 90.9222 304.168 93.6916C301.901 99.0622 297.693 103.357 292.409 105.682C289.704 106.881 286.778 107.488 283.826 107.467M283.826 66.798C281.408 66.7827 279.015 67.2672 276.788 68.2261C274.636 69.1492 272.68 70.4855 271.026 72.1635C269.382 73.8261 268.065 75.7897 267.145 77.9471C266.199 80.1505 265.722 82.5221 265.732 84.9243C265.717 87.3775 266.199 89.8052 267.145 92.0647C268.985 96.4713 272.444 99.9803 276.788 101.847C281.302 103.76 286.38 103.76 290.895 101.847C295.239 99.9803 298.698 96.4713 300.538 92.0647C301.483 89.8052 301.961 87.3775 301.946 84.9243C301.961 82.5221 301.478 80.1505 300.538 77.9471C299.613 75.7897 298.296 73.8261 296.657 72.1635C295.003 70.4906 293.047 69.1492 290.895 68.2261C288.668 67.2672 286.275 66.7827 283.857 66.798" fill="#000100"/>
          <path d="M355.094 105.086C355.094 105.591 354.913 106.075 354.591 106.458C354.229 106.896 353.681 107.141 353.118 107.111C352.575 107.111 352.062 106.876 351.71 106.458C351.348 106.091 351.142 105.601 351.122 105.086V81.3492C351.137 79.355 350.735 77.3863 349.945 75.5604C349.171 73.811 348.09 72.2197 346.748 70.8682C345.395 69.5013 343.796 68.4098 342.042 67.6448C340.262 66.8542 338.336 66.4513 336.396 66.4513C334.415 66.4411 332.454 66.8491 330.639 67.6448C328.884 68.4098 327.286 69.5013 325.933 70.8682C323.188 73.6478 321.66 77.4322 321.7 81.3645V105.101C321.68 105.616 321.474 106.106 321.112 106.473C320.725 106.901 320.177 107.141 319.603 107.126C318.507 107.126 317.839 106.453 317.592 105.086V65.008C317.592 63.6462 318.261 62.9679 319.603 62.9679C320.136 62.9577 320.659 63.1362 321.076 63.4779C321.509 63.8451 321.745 64.401 321.72 64.9723V69.6237C323.369 67.3337 325.541 65.4874 328.05 64.2378C332.947 61.7897 338.653 61.6163 343.686 63.7584C345.903 64.7223 347.924 66.1096 349.629 67.8386C353.133 71.4394 355.094 76.2897 355.094 81.3492V105.086Z" fill="#000100"/>
          <path d="M162.791 38.3794C162.791 42.2658 159.9 45.0455 155.842 45.0455H150.468V31.7134H155.928C159.91 31.7134 162.781 34.4777 162.781 38.3794M160.206 38.3794C160.302 36.0282 158.497 34.0391 156.179 33.9422C156.084 33.9422 155.988 33.9422 155.893 33.9422H152.982V42.8166H155.998C158.276 42.8727 160.171 41.0469 160.226 38.7313C160.226 38.6293 160.226 38.5222 160.226 38.4202" fill="#FF7915"/>
          <path d="M193.027 31.7134H190.513V45.0455H193.027V31.7134Z" fill="#FF7915"/>
          <path d="M227.738 33.9066C225.33 33.9066 223.374 35.8855 223.374 38.3336C223.374 40.7817 225.325 42.7606 227.738 42.7606C229.08 42.7198 230.357 42.1588 231.307 41.1999L232.791 42.8728C231.423 44.2907 229.563 45.1118 227.607 45.1577C223.927 45.2598 220.86 42.322 220.754 38.5886C220.754 38.5121 220.754 38.4356 220.754 38.3591C220.754 34.5492 223.771 31.637 227.703 31.637C229.598 31.6523 231.418 32.4173 232.771 33.7689L231.307 35.6356C230.408 34.5798 229.115 33.9525 227.738 33.9066Z" fill="#FF7915"/>
          <path d="M273.464 38.3795C273.464 42.2098 270.448 45.1577 266.466 45.1577C262.484 45.1577 259.462 42.2098 259.462 38.3795C259.462 34.5492 262.504 31.637 266.466 31.637C270.428 31.637 273.464 34.5543 273.464 38.3795ZM262.032 38.3795C262.047 40.8684 264.048 42.8779 266.501 42.8728C268.94 42.8422 270.89 40.8123 270.86 38.3387C270.83 35.8651 268.829 33.8862 266.391 33.9168C263.982 33.9474 262.042 35.9314 262.032 38.3795Z" fill="#FF7915"/>
          <path d="M304.118 31.7134L308.246 40.2665L312.358 31.7134H315.249V45.0455H312.962L312.942 35.5233L309.055 43.6735H307.421L303.535 35.5233V45.0455H301.207V31.7134H304.118Z" fill="#FF7915"/>
          <path d="M353.862 36.3036C353.862 39.3638 351.966 41.1234 348.663 41.1234H345.792V45.0455H343.278V31.7134H348.663C351.966 31.7134 353.862 33.371 353.862 36.3036ZM351.478 36.3801C351.478 34.7429 350.408 33.9422 348.532 33.9422H345.792V38.8741H348.557C350.433 38.8741 351.504 38.0581 351.504 36.3801" fill="#FF7915"/>
          <path d="M72.353 134.254C51.991 134.223 35.5053 117.469 35.5154 96.8131V87.0665H72.348C87.4561 87.0563 101.448 78.9928 109.191 65.829V96.8794C109.171 117.51 92.6899 134.229 72.353 134.249M29.4369 87.0665V96.8794C29.4369 100.511 29.8844 104.127 30.7693 107.646L10.3972 87.0665H29.4369ZM6.07844 80.9003V10.5167L23.268 27.9647C27.2298 31.9633 29.452 37.4053 29.4369 43.0768V80.9003H6.07844ZM109.186 43.5307C109.156 64.1816 92.6396 80.9054 72.2827 80.9003H35.5154V43.0768C35.5355 35.7732 32.6697 28.7604 27.5667 23.6091L10.3721 6.16111H72.348C92.6849 6.18151 109.166 22.9002 109.186 43.5307ZM115.264 43.5307C115.234 19.4983 96.0383 0.0255013 72.348 0H6.48568C2.90599 0.00510026 0.00502766 2.94285 0 6.57423V83.986C0 84.8071 0.32177 85.5925 0.894923 86.1689L43.263 128.975L43.3284 128.914C60.7492 145.194 87.8785 144.067 103.927 126.4C111.247 118.341 115.299 107.774 115.274 96.8131V43.5307" fill="#000100"/>
        </svg>

        <div v-if="!codigoEnviado" class="login-form">
          <h1 class="login-title">
            Recuperar <span class="login-title--highlight">Senha</span>
          </h1>
          <p class="login-subtitle">Insira seu e-mail para receber as instruções de recuperação.</p>

          <div class="field-group">
            <label class="field-label">E-mail</label>
            <div class="login-input">
              <span class="login-input__left-icon"><i class="icon-user"></i></span>
              <input
                type="text"
                placeholder="Digite seu e-mail"
                v-model="email"
                @keyup.enter="enviarCodigo()"
              />
            </div>
          </div>

          <b-button class="login-btn mt-4" block @click="enviarCodigo()">
            Enviar código
          </b-button>

          <div class="text-center mt-3">
            <router-link to="/login" class="forgot-password-link">
              Voltar ao login
            </router-link>
          </div>
        </div>

        <div v-else-if="codigoEnviado && !codigoConfirmado" class="login-form">
          <h1 class="login-title">
            Verificação de <span class="login-title--highlight">Segurança</span>
          </h1>
          <p class="login-subtitle">Um código foi enviado para o seu e-mail.</p>

          <div class="field-group">
            <label class="field-label">Código de verificação</label>
            <div class="login-input">
              <span class="login-input__left-icon"><i class="icon-lock"></i></span>
              <input
                type="text"
                placeholder="Ex.: 123456"
                v-model="codigo"
                @keyup.enter="validarCodigo()"
              />
            </div>
          </div>

          <b-button class="login-btn mt-4" block @click="validarCodigo()">
            Validar
          </b-button>

          <div class="text-center mt-3">
            <button
              class="forgot-password-link"
              @click="reenviarCodigo()"
              :disabled="reenvioCount != 0"
            >
              Reenviar código {{ reenvioCount != 0 ? formatSeconds(reenvioCount) : "" }}
            </button>
          </div>

          <div class="text-center mt-2">
            <router-link to="/login" class="forgot-password-link">
              Cancelar
            </router-link>
          </div>

          <div class="support-row mt-4">
            <span class="support-row__text">Não recebeu o código?</span>
            <a class="support-row__link" :href="retornarLinkWhatsapp()" target="_blank">
              <img src="./../../assets/img/iconewhats.png" alt="WhatsApp" class="support-row__whatsapp" />
              Fale Conosco
            </a>
          </div>
        </div>

        <div v-else-if="codigoEnviado && codigoConfirmado && !loggedIn" class="login-form">
          <h1 class="login-title">
            Criar <span class="login-title--highlight">Nova Senha</span>
          </h1>
          <p class="login-subtitle">Escolha uma senha segura para sua conta.</p>

          <div class="field-group">
            <label class="field-label">Nova senha</label>
            <div class="login-input">
              <span class="login-input__left-icon"><i class="icon-lock"></i></span>
              <input
                :type="novaSenhaTypeToggle"
                placeholder="Insira uma senha"
                v-model="senhaNova"
              />
              <span class="login-input__eye" @click="senhaNovaVisivel = !senhaNovaVisivel">
                <i :class="senhaNovaVisivel ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </span>
            </div>
          </div>

          <div class="field-group mt-3">
            <label class="field-label">Confirmar senha</label>
            <div class="login-input">
              <span class="login-input__left-icon"><i class="icon-lock"></i></span>
              <input
                :type="novaSenhaConfirmacaoTypeToggle"
                placeholder="Confirmar senha"
                v-model="senhaNovaConfirmacao"
              />
              <span class="login-input__eye" @click="senhaNovaConfirmacaoVisivel = !senhaNovaConfirmacaoVisivel">
                <i :class="senhaNovaConfirmacaoVisivel ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </span>
            </div>
          </div>

          <div class="password-requirements mt-4">
            <span class="password-requirements__title">Requisitos para uma senha segura:</span>
            <ul class="password-requirements__list">
              <li>
                <i :class="validacoesSenha.nroCaracteres ? 'icon-check' : 'icon-close'"
                   :style="{ color: validacoesSenha.nroCaracteres ? '#28a745' : '#dc3545' }"></i>
                Use pelo menos 8 caracteres
              </li>
              <li>
                <i :class="validacoesSenha.charMaiusculo ? 'icon-check' : 'icon-close'"
                   :style="{ color: validacoesSenha.charMaiusculo ? '#28a745' : '#dc3545' }"></i>
                Use caracteres maiúsculos
              </li>
              <li>
                <i :class="validacoesSenha.charMinusculo ? 'icon-check' : 'icon-close'"
                   :style="{ color: validacoesSenha.charMinusculo ? '#28a745' : '#dc3545' }"></i>
                Use caracteres minúsculos
              </li>
              <li>
                <i :class="validacoesSenha.contemNumeros ? 'icon-check' : 'icon-close'"
                   :style="{ color: validacoesSenha.contemNumeros ? '#28a745' : '#dc3545' }"></i>
                Insira números
              </li>
              <li>
                <i :class="validacoesSenha.charEspecial ? 'icon-check' : 'icon-close'"
                   :style="{ color: validacoesSenha.charEspecial ? '#28a745' : '#dc3545' }"></i>
                Insira caracteres especiais
              </li>
            </ul>
          </div>

          <b-button class="login-btn mt-3" block @click="alterarSenha()">
            Confirmar
          </b-button>
        </div>

        <resale-selector
          v-else
          :empresas="resales"
          :dataExpiracao="expirationDate"
          :usuario="user"
          :nroSuporte="telefoneSuporte"
        ></resale-selector>
      </div>
    </div>
  </div>
</template>

<script>
import LoginSlider from "../../components/LoginSlider.vue";
import ResaleSelector from "../../components/ResaleSelector.vue";
import ResetSenha from "./../../services/resetSenha";
import Autenticar from "./../../services/autenticar";
import Carrinho from "./../../services/carrinho";

export default {
  components: { LoginSlider, ResaleSelector },
  props: ["empresas", "usuario", "dataExpiracao", "nroSuporte"],
  name: "recuperarSenha",
  data() {
    return {
      email: "",
      codigo: "",
      reenvioCount: 0,
      telefoneSuporte: "",
      codigoEnviado: false,
      codigoConfirmado: false,
      senhaNova: "",
      senhaNovaConfirmacao: "",
      senhaNovaVisivel: false,
      senhaNovaConfirmacaoVisivel: false,
      validacoesSenha: {
        nroCaracteres: false,
        charMaiusculo: false,
        charMinusculo: false,
        contemNumeros: false,
        charEspecial: false
      },
      loggedIn: false,
      resales: [],
      user: "",
      expirationDate: ""
    };
  },
  mounted() {
    this.buscarWhatsappSuporte();
  },
  methods: {
    enviarCodigo() {
      if (this.email == "") {
        this.$helper.showMsg("Preencha o email.", "warning");
        return;
      }
      if (!this.validaFormatoEmail()) {
        this.$helper.showMsg("Insira um formato de email válido.", "warning");
        return;
      }
      ResetSenha.enviarCodigo(this.email)
        .then(response => {
          if (response.status == 204) {
            this.codigoEnviado = true;
          }
        })
        .catch(e => {
          this.email = "";
          this.codigoEnviado = false;
          this.$helper.showErrorResponse(e);
        });
    },
    reenviarCodigo() {
      this.enviarCodigo();
      this.reenvioCount = 120;
    },
    validarCodigo() {
      if (this.codigo == "") {
        this.$helper.showMsg("Preencha o código.", "warning");
        return;
      }
      const data = {
        email: this.email,
        codigo: this.codigo
      };
      ResetSenha.validarCodigo(data)
        .then(response => {
          const codigoValido = response.data.data.codigoValido;
          this.codigoConfirmado = codigoValido;
          if (!this.codigoConfirmado) {
            this.codigo = "";
            this.$helper.showMsg("Código não encontrado");
          }
        })
        .catch(e => {
          this.codigo = "";
          this.codigoConfirmado = false;
          this.$helper.showErrorResponse(e);
        });
    },
    alterarSenha() {
      if (this.senhaNova != this.senhaNovaConfirmacao) {
        this.$helper.showMsg("Ambas as senhas precisam ser iguais!", "warning");
        return;
      }
      for (const value of Object.values(this.validacoesSenha)) {
        if (!value) {
          this.$helper.showMsg(
            "A senha precisa atender todos os requisitos listados!",
            "warning"
          );
          return;
        }
      }
      ResetSenha.trocarSenha(this.email, this.senhaNova, this.codigo)
        .then(response => {
          if (response.status == 204) {
            this.$helper.showMsg("Senha alterada com sucesso!", "success");
            this.login();
          } else if (response.status == 200) {
            this.$helper.showMsg(response.data.msg, "warning");
          }
        })
        .catch(e => {
          this.$helper.showErrorResponse(e);
        });
    },
    useResale(resale) {
      this.$store.commit("login/CURRENT_RESALE", resale);
      this.$store.commit("login/CURRENT_USER", this.user);
      this.$store.commit("login/X_API_KEY", resale.key);
      this.$store.commit("login/EXPIRATION_DATE", this.expirationDate);
      this.loadCurrentCart();
      this.$router.push("/");
    },
    loadCurrentCart() {
      this.$store.commit("carrinho/RESET");
      Carrinho.getCarrinho()
        .then(response => {
          this.$store.commit("carrinho/CURRENT_CART", response.data.data);
        })
        .catch(() => {});
    },
    login() {
      this.resales = [];
      Autenticar.login(this.email, this.senhaNova)
        .then(response => {
          this.user = null;
          this.expirationDate = null;
          this.loggedIn = false;
          this.resales = response.data.keys;
          this.user = response.data.user;
          this.expirationDate = response.data.expiration_date;
          if (this.resales.length == 1) {
            this.useResale(this.resales[0]);
          } else {
            this.loggedIn = true;
          }
        })
        .catch(e => {
          this.loggedIn = false;
          this.resales = [];
          this.$helper.showErrorResponse(e);
          this.$router.push({ name: "Login" });
        });
    },
    buscarWhatsappSuporte() {
      ResetSenha.buscaTelefoneSuporte().then(response => {
        this.telefoneSuporte = response.data.data.whatsapp;
      });
    },
    validaFormatoEmail() {
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regexEmail.test(this.email);
    },
    formatSeconds(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${this.padZero(minutes)}:${this.padZero(remainingSeconds)}`;
    },
    padZero(number) {
      return number < 10 ? `0${number}` : number;
    }
  },
  computed: {
    retornarLinkWhatsapp() {
      return () => {
        return this.$store.state.configPadrao.linkWhatsapp + this.telefoneSuporte;
      };
    },
    novaSenhaTypeToggle() {
      return this.senhaNovaVisivel ? "text" : "password";
    },
    novaSenhaConfirmacaoTypeToggle() {
      return this.senhaNovaConfirmacaoVisivel ? "text" : "password";
    }
  },
  watch: {
    codigoEnviado(codigoEnviado) {
      if (codigoEnviado) {
        this.reenvioCount = 120;
      }
    },
    reenvioCount(reenvioCount) {
      if (reenvioCount > 0) {
        setTimeout(() => {
          this.reenvioCount--;
        }, 1000);
      }
    },
    senhaNova(senhaNova) {
      this.validacoesSenha.nroCaracteres = senhaNova.length > 8;
      this.validacoesSenha.charMaiusculo = /[A-Z]/.test(senhaNova);
      this.validacoesSenha.charMinusculo = /[a-z]/.test(senhaNova);
      this.validacoesSenha.charEspecial = /[.,!@#$%^&*()_+\-=]/.test(senhaNova);
      this.validacoesSenha.contemNumeros = /\d/.test(senhaNova);
    }
  }
};
</script>

<style scoped>
.login-layout {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #ffffff;
}

.login-layout__cover {
  flex: 0 0 38%;
  max-width: 38%;
  height: 100%;
  padding: 1%;
  padding-right: 2%;
}

.login-layout__auth {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 2rem;
}

.login-layout__auth-content {
  width: 100%;
  max-width: 500px;
  margin-top: 2rem;
}

.login-logo {
  display: block;
  max-width: 200px;
  height: auto;
  margin: 0 auto 2rem;
}

.login-form {
  width: 100%;
}

.login-form .login-title {
  text-align: center;
}

.login-title {
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1.3;
  color: #000000;
  margin: 0 0 0.5rem;
}

.login-title--highlight {
  color: #f84e22;
  font-weight: 700;
}

.login-subtitle {
  font-size: 16px;
  font-weight: 400;
  color: #888787;
  margin: 0 0 1.5rem;
  text-align: center;
}

.field-group {
  width: 100%;
}

.field-label {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 6px;
  display: block;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.login-input {
  display: flex;
  align-items: center;
  border: 1px solid #888787;
  border-radius: 12px;
  height: 48px;
  overflow: hidden;
  background: #ffffff;
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 90%;
  margin: 0 auto;
}

.login-input:focus-within {
  border-color: orangered;
  box-shadow: 0 0 0 0.15rem rgba(255, 68, 0, 0.15);
}

.login-input__left-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888787;
  flex-shrink: 0;
  padding-left: 16px;
}

.login-input input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  height: 100%;
  padding: 0 14px;
  font-size: 15px;
  color: #333333;
}

.login-input input::placeholder {
  color: #aaaaaa;
}

.login-input__eye {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px 0 0;
  color: #888787;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.2s;
}

.login-input__eye:hover {
  color: #333333;
}

.login-btn {
  background-color: #f84e22 !important;
  border-color: #f84e22 !important;
  color: #ffffff !important;
  border-radius: 18px !important;
  height: 48px !important;
  font-size: 16px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.3px;
  width: 90%;
  margin: 0 auto;
}

.login-btn:hover {
  background-color: #e0431d !important;
  border-color: #e0431d !important;
}

.login-btn:active {
  background-color: #c93a18 !important;
  border-color: #c93a18 !important;
}

.forgot-password-link {
  font-size: 14px;
  color: #666666;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.forgot-password-link:hover {
  color: #f84e22;
  text-decoration: underline;
}

.support-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.support-row__text {
  font-size: 14px;
  color: #666666;
}

.support-row__link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333333;
  text-decoration: underline;
}

.support-row__link:hover {
  color: #f84e22;
}

.support-row__whatsapp {
  width: 20px;
  height: 20px;
}

.password-requirements {
  padding: 12px 0;
}

.password-requirements__title {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  display: block;
  margin-bottom: 8px;
}

.password-requirements__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.password-requirements__list li {
  font-size: 13px;
  color: #555555;
  padding: 3px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Responsivo */
@media (max-width: 960px) {
  .login-layout {
    flex-direction: column;
  }

  .login-layout__cover {
    flex: 0 0 35%;
    max-width: 100%;
    width: 100%;
    padding: 1%;
    padding-bottom: 0;
  }

  .login-layout__auth {
    flex: 1;
    padding: 1.5rem 2rem;
  }
}

@media (max-width: 600px) {
  .login-layout__cover {
    display: none;
  }

  .login-layout__auth {
    padding: 1.5rem;
  }
}
</style>
